<template>
  <main class="teachers-profile" style="background: #005d79 !important;">
    <SimpleHeader route="/main">
      <template v-slot:title>
        <span>
         {{$ml.get('כיתה משחקת')}}
        </span>
      </template>
      <span slot="additional">
        <sidebar-toggler />
        <router-link :to="'/'" class="home-anchor" style="color: white;">
          <svg
                    width="22"
                    height="20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style="position:absolute; top: 4px; right: 24px;"
                  >
                    <path
                      d="M10.3312 0.926701L10.2632 0.863573L10.1951 0.926701L0.931976 9.52313L0.85877 9.59106L0.926614 9.66436L1.78441 10.591L1.85245 10.6645L1.92585 10.5964L2.59093 9.9786V17V17.1H2.69093H9.00112H9.10112V17V10.7907H11.4252V17V17.1H11.5252H17.8354H17.9354V17V9.9786L18.6005 10.5964L18.6739 10.6645L18.7419 10.591L19.5997 9.66436L19.6675 9.59106L19.5943 9.52313L10.3312 0.926701ZM16.4733 8.6246V15.6381H12.8872V9.42883V9.32883H12.7872H7.73908H7.63908V9.42883V15.6381H4.05297V8.6246L10.2632 2.85187L16.4733 8.6246Z"
                      fill="white"
                      stroke="white"
                      stroke-width="0.2"
                    />
                  </svg>
        </router-link>
      </span>
    </SimpleHeader>
    <app-loading class="sm-cont">
      <template>
        <div class="background"></div>
        <!--div class="teacher-header">
          <div class="title">

            <span class="second">  {{$ml.get('הכיתה יועדה ע”י ההנהלה להפעיל תורני משחקים')}}  </span>
            <button @click="openTutorial" class="first">{{$ml.get('הסבר')}} </button>
          </div>
        </div-->

        <div  v-if="$store.getters['teacher-targets/showGamesShifts']" class="teacher-checkbox">
          <div class="question">
            {{$ml.get('האם תורנות המשחקים פעילה בכיתתך כעת')}}?
          </div>
          <TeacherProfileRadio @input="change" v-model="radio"/>
        </div>
        <div class="teacher-links">

          <router-link class="link-element" style="margin-top: 45px;" :to="{name: 'teacher-educational-games'}">
            <svg width="42" height="40" viewBox="0 0 42 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5.45455 0C4.00791 0 2.62053 0.574674 1.5976 1.5976C0.574674 2.62053 0 4.00791 0 5.45455C0 6.90118 0.574674 8.28857 1.5976 9.31149C2.62053 10.3344 4.00791 10.9091 5.45455 10.9091C6.90118 10.9091 8.28857 10.3344 9.31149 9.31149C10.3344 8.28857 10.9091 6.90118 10.9091 5.45455C10.9091 4.00791 10.3344 2.62053 9.31149 1.5976C8.28857 0.574674 6.90118 0 5.45455 0ZM14.5455 1.81818V5.45455H36.3636V25.4545H14.5455V26.9673C14.513 27.1637 14.513 27.364 14.5455 27.5604V29.0909H38.1818H40C40.2409 29.0943 40.4801 29.0498 40.7037 28.96C40.9273 28.8701 41.1308 28.7367 41.3024 28.5676C41.4739 28.3984 41.6102 28.1968 41.7032 27.9745C41.7962 27.7522 41.8441 27.5137 41.8441 27.2727C41.8441 27.0318 41.7962 26.7932 41.7032 26.5709C41.6102 26.3486 41.4739 26.1471 41.3024 25.9779C41.1308 25.8087 40.9273 25.6753 40.7037 25.5855C40.4801 25.4957 40.2409 25.4511 40 25.4545V3.63636C40 3.15417 39.8084 2.69173 39.4674 2.35077C39.1264 2.0098 38.664 1.81823 38.1818 1.81818H14.5455ZM3.63636 14.5455C1.62727 14.5455 0 16.1727 0 18.1818V29.0909H10.9091V20C10.9091 18.9964 11.7236 18.1818 12.7273 18.1818H14.5455H21.8182C22.0591 18.1852 22.2983 18.1407 22.5219 18.0509C22.7455 17.961 22.949 17.8276 23.1206 17.6585C23.2921 17.4893 23.4284 17.2877 23.5214 17.0654C23.6144 16.8431 23.6623 16.6046 23.6623 16.3636C23.6623 16.1227 23.6144 15.8841 23.5214 15.6618C23.4284 15.4396 23.2921 15.238 23.1206 15.0688C22.949 14.8996 22.7455 14.7662 22.5219 14.6764C22.2983 14.5866 22.0591 14.542 21.8182 14.5455H14.5455H9.09091H3.63636ZM3.63636 32.7273C2.67194 32.7273 1.74702 33.1104 1.06507 33.7923C0.383116 34.4743 0 35.3992 0 36.3636C0 37.3281 0.383116 38.253 1.06507 38.9349C1.74702 39.6169 2.67194 40 3.63636 40C4.60079 40 5.52571 39.6169 6.20766 38.9349C6.88961 38.253 7.27273 37.3281 7.27273 36.3636C7.27273 35.3992 6.88961 34.4743 6.20766 33.7923C5.52571 33.1104 4.60079 32.7273 3.63636 32.7273ZM14.5455 32.7273C13.581 32.7273 12.6561 33.1104 11.9742 33.7923C11.2922 34.4743 10.9091 35.3992 10.9091 36.3636C10.9091 37.3281 11.2922 38.253 11.9742 38.9349C12.6561 39.6169 13.581 40 14.5455 40C15.5099 40 16.4348 39.6169 17.1168 38.9349C17.7987 38.253 18.1818 37.3281 18.1818 36.3636C18.1818 35.3992 17.7987 34.4743 17.1168 33.7923C16.4348 33.1104 15.5099 32.7273 14.5455 32.7273ZM25.4545 32.7273C24.4901 32.7273 23.5652 33.1104 22.8832 33.7923C22.2013 34.4743 21.8182 35.3992 21.8182 36.3636C21.8182 37.3281 22.2013 38.253 22.8832 38.9349C23.5652 39.6169 24.4901 40 25.4545 40C26.419 40 27.3439 39.6169 28.0258 38.9349C28.7078 38.253 29.0909 37.3281 29.0909 36.3636C29.0909 35.3992 28.7078 34.4743 28.0258 33.7923C27.3439 33.1104 26.419 32.7273 25.4545 32.7273ZM36.3636 32.7273C35.3992 32.7273 34.4743 33.1104 33.7923 33.7923C33.1104 34.4743 32.7273 35.3992 32.7273 36.3636C32.7273 37.3281 33.1104 38.253 33.7923 38.9349C34.4743 39.6169 35.3992 40 36.3636 40C37.3281 40 38.253 39.6169 38.9349 38.9349C39.6169 38.253 40 37.3281 40 36.3636C40 35.3992 39.6169 34.4743 38.9349 33.7923C38.253 33.1104 37.3281 32.7273 36.3636 32.7273Z"
                fill="#06364B"/>
            </svg>
            <span>{{$ml.get('משחקים לכיתה')}} </span>
          </router-link>

          <router-link class="link-element" :to="{name: 'teacher-educational-classes'}">
            <svg width="44" height="40" viewBox="0 0 44 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9 0C5.14 0 2 3.14 2 7C2 9.42374 3.24026 11.5634 5.11719 12.8203C2.15369 14.0889 0 16.7391 0 20H4C4 17.9469 6.06037 16 9 16C11.9396 16 14 17.9469 14 20H18C18 16.7391 15.8463 14.0889 12.8828 12.8203C14.7597 11.5634 16 9.42374 16 7C16 3.14 12.86 0 9 0ZM22 0V4C29.5221 4 35.7991 9.17001 37.5273 16.1328L41.4102 15.168C39.2464 6.45077 31.3579 0 22 0ZM9 4C10.654 4 12 5.346 12 7C12 8.654 10.654 10 9 10C7.346 10 6 8.654 6 7C6 5.346 7.346 4 9 4ZM35 20C31.14 20 28 23.14 28 27C28 29.4237 29.2403 31.5634 31.1172 32.8203C28.1537 34.0889 26 36.7391 26 40H30C30 37.9469 32.0604 36 35 36C37.9396 36 40 37.9469 40 40H44C44 36.7391 41.8463 34.0889 38.8828 32.8203C40.7597 31.5634 42 29.4237 42 27C42 23.14 38.86 20 35 20ZM35 24C36.654 24 38 25.346 38 27C38 28.654 36.654 30 35 30C33.346 30 32 28.654 32 27C32 25.346 33.346 24 35 24ZM6.73047 24.8008L2.91797 26C5.471 34.1194 13.0657 40 22 40V36C14.8183 36 8.76944 31.2853 6.73047 24.8008Z"
                fill="#06364B"/>
            </svg>
            <span>{{$ml.get('שעת חינוך')}}</span>
          </router-link>

          <router-link class="link-element" :to="{name: 'teacher-students-list'}">
            <svg enable-background="new 0 0 91 91" height="91px" id="Layer_1" version="1.1" viewBox="0 0 91 91" width="91px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><g><path d="M26.939,49.462c11.592,0,21.029-9.5,21.029-21.176S38.531,7.11,26.939,7.11    c-11.588,0-21.018,9.5-21.018,21.176S15.352,49.462,26.939,49.462z" fill="#06364B"/><path d="M44.877,46.202c-4.586,4.643-10.932,7.525-17.938,7.525c-6.934,0-13.219-2.828-17.793-7.393    c-5.633,2.715-8.414,6.75-8.414,12.334V78.19c2.818,1.563,9.678,7.268,26.553,7.268c17.029,0,24.127-5.578,26.24-7.088V58.665    C53.525,52.974,50.666,48.897,44.877,46.202z" fill="#06364B"/></g><path d="M87.191,20.282H57.453c-1.846,0-3.34-1.494-3.34-3.34c0-1.844,1.494-3.34,3.34-3.34h29.738   c1.842,0,3.34,1.496,3.34,3.34C90.531,18.788,89.033,20.282,87.191,20.282z" fill="#06364B"/><path d="M87.191,39.185H57.453c-1.846,0-3.34-1.496-3.34-3.34c0-1.846,1.494-3.34,3.34-3.34h29.738   c1.842,0,3.34,1.494,3.34,3.34C90.531,37.688,89.033,39.185,87.191,39.185z" fill="#06364B"/><path d="M87.193,58.085H62.418c-1.846,0-3.34-1.494-3.34-3.34c0-1.844,1.494-3.34,3.34-3.34h24.775   c1.844,0,3.34,1.496,3.34,3.34C90.533,56.591,89.037,58.085,87.193,58.085z" fill="#06364B"/><path d="M87.193,76.987H62.418c-1.846,0-3.34-1.496-3.34-3.34c0-1.846,1.494-3.34,3.34-3.34h24.775   c1.844,0,3.34,1.494,3.34,3.34C90.533,75.491,89.037,76.987,87.193,76.987z" fill="#06364B"/></g></svg>
            <span>{{$ml.get('רשימת תלמידים')}} </span>
          </router-link>
          <!--router-link class="link-element" :to="{name: 'teacher-inventing-games'}">
            <svg width="43" height="40" viewBox="0 0 43 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7.39062 0L5.23103 2.11516L8.44643 5.26439L10.606 3.14924L7.39062 0ZM35.6094 0L32.394 3.14924L34.5536 5.26439L37.769 2.11516L35.6094 0ZM21.5 0.940071C20.9961 0.945946 20.4802 0.975324 19.9643 1.03408C19.9463 1.03408 19.9343 1.03408 19.9163 1.03408C13.6895 1.73326 8.73438 6.66275 7.87054 12.738C7.18066 17.6263 9.23828 22.0564 12.6696 24.9119C14.1394 26.1457 15.0452 27.7908 15.3571 29.4712V38.4959H18.8605C19.3944 39.3948 20.3662 40 21.5 40C22.6338 40 23.6056 39.3948 24.1395 38.4959H27.6429V32.4794H27.7868V30.6933C27.7868 28.49 28.9566 26.2632 30.8583 24.5358C33.4018 22.0447 35.3214 18.5018 35.3214 14.4301C35.3214 6.99765 29.0766 0.869565 21.5 0.940071ZM21.5 3.9483C27.4329 3.86604 32.25 8.62515 32.25 14.4301C32.25 17.5793 30.7623 20.3525 28.6987 22.3737L28.7467 22.4207C26.683 24.3067 25.3633 26.7744 25.0033 29.4712H18.2846C17.9487 26.8919 16.8149 24.4007 14.6853 22.6087C11.9738 20.3467 10.3541 16.9506 10.894 13.114C11.5658 8.3725 15.4891 4.56522 20.3002 4.0423C20.7021 3.9953 21.1041 3.95417 21.5 3.9483ZM0 14.4301V17.4383H4.60714V14.4301H0ZM38.3929 14.4301V17.4383H43V14.4301H38.3929ZM8.44643 26.604L5.23103 29.7532L7.39062 31.8684L10.606 28.7192L8.44643 26.604ZM34.5536 26.604L32.394 28.7192L35.6094 31.8684L37.769 29.7532L34.5536 26.604ZM18.4286 32.4794H24.5714V35.4877H18.4286V32.4794Z"
                fill="#06364B"/>
            </svg>
            <span>{{$ml.get('קורס המצאת משחקים')}} </span>
          </router-link-->

          <router-link class="link-element" :to="{name: 'teacher-individual-plan'}">
            <svg  width="50" height="40" viewBox="0 0 50 40" fill="none"  xmlns="http://www.w3.org/2000/svg">
            <path d="M4.06055 0V3H9.43946L0 12.4395L2.12109 14.5605L11.5605 5.12109V10.5H14.5605V0H4.06055ZM28.0605 0C25.5931 0 23.5605 2.03255 23.5605 4.5C23.5605 6.96745 25.5931 9 28.0605 9C30.528 9 32.5605 6.96745 32.5605 4.5C32.5605 2.03255 30.528 0 28.0605 0ZM28.0605 3C28.9081 3 29.5605 3.65245 29.5605 4.5C29.5605 5.34755 28.9081 6 28.0605 6C27.213 6 26.5605 5.34755 26.5605 4.5C26.5605 3.65245 27.213 3 28.0605 3ZM26.5605 10.5C23.2515 10.5 20.5605 13.191 20.5605 16.5V24.3721L23.5605 25.8721V36H26.5605V24.0205L23.5605 22.5205V16.5C23.5605 14.8455 24.906 13.5 26.5605 13.5H29.5605C31.215 13.5 32.5605 14.8455 32.5605 16.5V22.5205L29.5605 24.0205V36H32.5605V25.8721L35.5605 24.3721V16.5C35.5605 13.191 32.8695 10.5 29.5605 10.5H26.5605ZM14.5605 18V36H17.5605V18H14.5605ZM8.56055 24V36H11.5605V24H8.56055ZM2.56055 30V36H5.56055V30H2.56055Z" fill="#06364B"/>
          </svg>
            <span>{{$ml.get('תוכנית משחקים אישית')}} </span>
          </router-link>
        </div>
      <div class="router-links-wrapper">
        <!--TeacherLinkTo
          bgColor="#FDC671"
          textColor="#06364B"
          style="position: relative;height: 60px"
          route="teacher-individual-plan">
        <span class="icon">
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.06055 0V3H9.43946L0 12.4395L2.12109 14.5605L11.5605 5.12109V10.5H14.5605V0H4.06055ZM28.0605 0C25.5931 0 23.5605 2.03255 23.5605 4.5C23.5605 6.96745 25.5931 9 28.0605 9C30.528 9 32.5605 6.96745 32.5605 4.5C32.5605 2.03255 30.528 0 28.0605 0ZM28.0605 3C28.9081 3 29.5605 3.65245 29.5605 4.5C29.5605 5.34755 28.9081 6 28.0605 6C27.213 6 26.5605 5.34755 26.5605 4.5C26.5605 3.65245 27.213 3 28.0605 3ZM26.5605 10.5C23.2515 10.5 20.5605 13.191 20.5605 16.5V24.3721L23.5605 25.8721V36H26.5605V24.0205L23.5605 22.5205V16.5C23.5605 14.8455 24.906 13.5 26.5605 13.5H29.5605C31.215 13.5 32.5605 14.8455 32.5605 16.5V22.5205L29.5605 24.0205V36H32.5605V25.8721L35.5605 24.3721V16.5C35.5605 13.191 32.8695 10.5 29.5605 10.5H26.5605ZM14.5605 18V36H17.5605V18H14.5605ZM8.56055 24V36H11.5605V24H8.56055ZM2.56055 30V36H5.56055V30H2.56055Z" fill="#06364B"/>
          </svg>
         </span>
          <span
            style="margin-right: 20px;display: flex;align-items: center;"
            class="title">
            <span class="main">{{$ml.get('תוכנית משחקים אישית')}}</span>
            <span
             class="small">({{$ml.get('תמ"א')}})</span>
          </span>
        </TeacherLinkTo-->


        <TeacherLinkTo
          style="position: relative;height: 60px"
          route="teacher-reports">
        <span class="icon">
         <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17 0C7.62635 0 0 7.62635 0 17C0 26.3737 7.62635 34 17 34C26.3737 34 34 26.3737 34 17C34 13.6022 32.9945 10.4361 31.2701 7.77675L30.6104 8.43648L30.1889 8.85802C31.6583 11.2284 32.5217 14.0117 32.5217 17C32.5217 25.5591 25.5591 32.5217 17 32.5217C8.44087 32.5217 1.47826 25.5591 1.47826 17C1.47826 8.44087 8.44087 1.47826 17 1.47826C20.6316 1.47826 23.9629 2.74768 26.6087 4.84621V6.34613L24.8085 8.14631C22.7239 6.30286 19.9949 5.17391 17 5.17391C10.4794 5.17391 5.17391 10.4794 5.17391 17C5.17391 23.5206 10.4794 28.8261 17 28.8261C23.5206 28.8261 28.8261 23.5206 28.8261 17C28.8261 14.5394 28.0689 12.2523 26.7776 10.3579L25.7064 11.4291C26.7397 13.0397 27.3478 14.9482 27.3478 17C27.3478 22.7061 22.7061 27.3478 17 27.3478C11.2939 27.3478 6.65217 22.7061 6.65217 17C6.65217 11.2939 11.2939 6.65217 17 6.65217C19.5879 6.65217 21.9486 7.61433 23.7633 9.19149L21.1417 11.8131C20.0045 10.9009 18.5681 10.3478 17 10.3478C13.3324 10.3478 10.3478 13.3324 10.3478 17C10.3478 20.6676 13.3324 23.6522 17 23.6522C20.6676 23.6522 23.6522 20.6676 23.6522 17C23.6522 15.9748 23.4122 15.0079 22.9968 14.1402L21.8693 15.2662C22.063 15.8087 22.1739 16.3917 22.1739 17C22.1739 19.853 19.853 22.1739 17 22.1739C14.147 22.1739 11.8261 19.853 11.8261 17C11.8261 14.147 14.147 11.8261 17 11.8261C18.1604 11.8261 19.2286 12.2149 20.0922 12.8626L17.3811 15.5737C17.2569 15.5399 17.1288 15.5224 17 15.5217C16.6079 15.5217 16.2319 15.6775 15.9547 15.9547C15.6775 16.2319 15.5217 16.6079 15.5217 17C15.5217 17.3921 15.6775 17.7681 15.9547 18.0453C16.2319 18.3225 16.6079 18.4783 17 18.4783C17.3921 18.4783 17.7681 18.3225 18.0453 18.0453C18.3225 17.7681 18.4783 17.3921 18.4783 17C18.4782 16.8708 18.4612 16.7422 18.4277 16.6174L27.6539 7.3913H29.5652L33.2609 3.69565H30.3043V0.73913L27.4417 3.60182C24.5575 1.34843 20.9354 0 17 0Z" fill="white"/>
         </svg>


         </span>
          <span  class="title">{{$ml.get('עמידה ביעדים')}}</span>
        </TeacherLinkTo>
      </div>
        <TeacherTutorial />
      </template>
    </app-loading>
  </main>
</template>

<script>

import SimpleHeader from "@/components/SimpleHeader.vue";
import SidebarToggler from "@/components/SidebarToggler.vue";
import TeacherProfileRadio from "@/components/teacher/TeacherProfileRadio.vue";
import TeacherLinkTo from "@/components/teacher/TeacherLinkTo";
import TeacherTutorial from "@/components/modals/modal/TeacherTutorial";
import {TeacherAPI} from "@/api";

export default {
  data() {
    return {
      index: 0,
      popup_showed: false,
      radio: '',
      loading: {
        next: false,
        sync: false
      },
    };
  },
  components: {

    // GiftLine,
    SimpleHeader,
    SidebarToggler,
    TeacherProfileRadio,
    TeacherLinkTo,
    TeacherTutorial,
  },
  computed: {
    link() {
      return this.$store.getters['tutorials/isUsed']('teacherTutorial') ? 'teacher-educational-classes' : 'teacher-tutorials';
    }
  },


  methods: {
    openTutorial(){
      this.$store.commit('modals/teacher-tutorial/open');
    },
    change(value){
        this.$store.dispatch('teacher-targets/updateGamesShifts', value === 'כן' );
    }
  },
  created() {
    window.fbq("track", "ניהול מורים");
    this.radio =  this.$store.getters['teacher-targets/gamesShifts'] ?   'כן' :  'לא';

  },
};
</script>

<style lang="scss" scoped>

.teachers-profile {
  background: rgba(0, 93, 121, 0.91);
  padding-bottom: 0 !important;
  display: flex;
  flex-direction: column;


  .app-loading {

    flex-grow: 1;
    min-height: 450px;

    @media screen and (min-width: 600px) {
      border-left:2px solid #005D79;
      border-right:2px solid #005D79;
      border-radius: 3px;
    }
    .teacher-header {
      position: absolute;
      z-index: 10;
      top: 0;
      width: 100%;
      margin: 17px auto 0;
      padding: 0 10px;
      @media screen and (max-width: 330px){
        width: 300px;
      }
      .title {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .first {
          font-size: 12px;
          line-height: 16px;
          text-align: center;
          background: #3FBCD4;
          border-radius: 2px;
          padding: 2px 10px;
          color: #FFFFFF;
        }

        .second {

          font-weight: bold;
          font-size: 14px;
          line-height: 19px;
          text-align: right;

          color: #FFFFFF;
        }
      }
    }

    .teacher-checkbox {
      width: 310px;
      margin: 10px auto;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .question {
        font-size: 12px;
        text-align: right;
        color: #00465B;
      }
    }

    .teacher-links {
      padding: 0 10px 20px 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex-grow: 1;
      position: relative;
      // background-image: url("../assets/img/main-page/method-draw-image.svg");
      width: 100%;
      height: 100%;
      .link-element {
        margin: 12px auto;
        padding: 10px 20px;
        background: #FFFFFF;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        width: 350px;
        height: 110px;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: space-between;
        border-radius: 5px;
        @media screen and (max-width: 330px){
          width: 300px;
        }
        span {
          font-style: normal;
          font-weight: bold;
          font-size: 22px;
          text-align: center;
          color: #06364B;
          margin-right: 18px;
        }

        svg {
          margin-top: 7px;
        }
      }
    }
    .title{

      display: flex;
      align-items: center;
      .main{
        font-size: 22px;
        @media screen and (max-width: 350px){
          font-size: 18px;
        }
      }
      .small{
        font-size: 16px;
        margin-right: 5px;
        margin-top: 5px;
        @media screen and (max-width: 350px){
          font-size: 14px;
        }
      }
    }
    .footer {

      width: 100%;

      .treatment {
        height: 80px;
      }

      .report {
        height: 80px;
      }
    }
  }
}
</style>
